import { makeStyles } from '@material-ui/core/styles';

const useReleveHeuresStyles = makeStyles((theme) => ({
    root: { paddingBottom: theme.spacing(12), fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif' },
    headerCard: { padding: theme.spacing(3), borderRadius: 16, marginBottom: theme.spacing(3), boxShadow: '0 4px 12px rgba(0,0,0,0.05)', background: 'linear-gradient(135deg, #ffffff 0%, #f9fbfd 100%)' },
    recapCard: { padding: theme.spacing(3), borderRadius: 16, marginBottom: theme.spacing(3), backgroundColor: '#f0f7ff', border: '1px solid #c3dafe' },

    dayCard: {
        borderRadius: 16,
        marginBottom: theme.spacing(2),
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        border: '1px solid #edf2f7',
        overflow: 'hidden',
        transition: 'all 0.2s ease-in-out'
    },
    dayHeader: {
        padding: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#ffffff',
        userSelect: 'none'
    },
    dayBody: {
        padding: theme.spacing(2),
        backgroundColor: '#fafbfc',
        borderTop: '1px solid #edf2f7'
    },

    totalBadge: { fontWeight: 'bold', fontSize: '1rem', color: theme.palette.primary.main, background: '#e3f2fd', padding: '4px 12px', borderRadius: 20 },

    inputRounded: {
        '& .MuiOutlinedInput-root': { borderRadius: 12, backgroundColor: '#ffffff', height: 48 }
    },
    formInputEqual: {
        '& .MuiOutlinedInput-root': { borderRadius: 12, backgroundColor: '#ffffff', height: 48, cursor: 'pointer' },
        '& .MuiOutlinedInput-input': { padding: '12px 8px', fontSize: '0.9rem', textAlign: 'center', fontWeight: 600, cursor: 'pointer' },
        '& .MuiSelect-select.MuiSelect-select': { paddingRight: '24px', textAlign: 'center' }
    },

    bottomBar: { position: 'fixed', bottom: 0, left: 0, right: 0, background: '#fff', padding: theme.spacing(2), boxShadow: '0 -4px 12px rgba(0,0,0,0.05)', zIndex: 1000, display: 'flex', justifyContent: 'center', gap: theme.spacing(2) },
    validationBlock: { padding: theme.spacing(2), backgroundColor: '#f8fafc', borderRadius: 12, marginBottom: theme.spacing(2) },

    clockDisplay: { backgroundColor: '#2b6cb0', color: '#fff', padding: theme.spacing(2), borderRadius: 12, textAlign: 'center', marginBottom: theme.spacing(2) },
    timeUnit: { fontSize: '2.8rem', fontWeight: 'bold', cursor: 'pointer', padding: '0 8px', borderRadius: 8, transition: 'background-color 0.2s' },
    timeUnitActive: { backgroundColor: 'rgba(255,255,255,0.2)', color: '#ffffff' },
    timeUnitInactive: { color: 'rgba(255,255,255,0.6)' },
    gridCellBtn: { width: '100%', height: 44, borderRadius: 10, fontWeight: 'bold', fontSize: '0.95rem' }
}));

export default useReleveHeuresStyles;
